import { connectMediaStore } from './withOwnReduxStore';
import { getCurrentGallectionSubfolders } from '../selectors';
const mapStateToProps = (state)=>({
        subfolders: getCurrentGallectionSubfolders(state)
    });
export default connectMediaStore(mapStateToProps);
